import { useNavigate } from "react-router-dom"
import { AuthService } from "../services/auth.service"
import { useCallback } from "react"

export const useLogout = () => {
  const navigate = useNavigate()

  return useCallback(() => {
    AuthService.clearAuth()
    navigate("/login", { replace: true })
  }, [navigate])
}
